import { getCurrentToken } from '../utils/auth';

export interface GenerateNameRequest {
  prompt: string;
  type?: 'game' | 'art' | 'animation';
}

interface GenerateNameResponse {
  name: string;
}

export async function generateName(request: GenerateNameRequest): Promise<string> {
  const { prompt, type } = request;
  try {
    const functionURL = process.env.REACT_APP_SUPABASE_FUNCTIONS_URL;

    // console.log('Generating name with:', { 
    //   url: `${functionURL}/generate-name`,
    //   prompt,
    //   type,
    // });

    // Ensure the function URL is available
    if (!functionURL) {
      console.error('Missing Supabase configuration: REACT_APP_SUPABASE_FUNCTIONS_URL is required.');
      throw new Error('Missing Supabase configuration');
    }

    // Get auth token for Supabase
    const authToken = await getCurrentToken();
    
    // Check for authentication token before proceeding
    if (!authToken) {
      console.error('User is not logged in or token is expired.');
      throw new Error('Authentication required for this operation.');
    }

    const response = await fetch(`${functionURL}/generate-name`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify({
        prompt,
        type,
      }),
    });

    // console.log('Name generation response:', { 
    //   status: response.status,
    //   ok: response.ok,
    //   statusText: response.statusText
    // });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Name generation failed:', { 
        status: response.status, 
        error: errorText 
      });
      throw new Error('Name generation failed');
      // return 'Game Name';
    }

    const data = await response.json() as GenerateNameResponse;
    // console.log('Generated name:', data.name);
    return data.name || 'Game Name';
  } catch (error) {
    console.error('Error generating name:', error);
    throw error;
    // return 'Game Name';
  }
}